/**
 * Mia Flow Tenant/Project Selection Manager
 * Manages selected tenant and project persistence in localStorage
 * Extracted from the original MiaFlowAuth to keep these utilities separate from authentication
 */

class MiaFlowTenantManager {
  /**
   * Get selected tenant from localStorage
   */
  getSelectedTenant() {
    try {
      const stored = localStorage.getItem('mia_selectedTenant');
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  /**
   * Set selected tenant in localStorage and dispatch event
   */
  setSelectedTenant(tenant) {
    try {
      if (tenant) {
        localStorage.setItem('mia_selectedTenant', JSON.stringify(tenant));
      } else {
        localStorage.removeItem('mia_selectedTenant');
      }
      
      // Dispatch event for other components to react
      window.dispatchEvent(new CustomEvent('mia-flow-tenant-changed', { 
        detail: { tenant } 
      }));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to save selected tenant:', error);
    }
  }

  /**
   * Get selected project from localStorage
   */
  getSelectedProject() {
    try {
      const stored = localStorage.getItem('mia_selectedProject');
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  }

  /**
   * Set selected project in localStorage and dispatch event
   */
  setSelectedProject(project) {
    try {
      if (project) {
        localStorage.setItem('mia_selectedProject', JSON.stringify(project));
      } else {
        localStorage.removeItem('mia_selectedProject');
      }
      
      // Dispatch event for other components to react
      window.dispatchEvent(new CustomEvent('mia-flow-project-changed', { 
        detail: { project } 
      }));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to save selected project:', error);
    }
  }

  /**
   * Clear all stored tenant/project data
   */
  clearSelection() {
    try {
      localStorage.removeItem('mia_selectedTenant');
      localStorage.removeItem('mia_selectedProject');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to clear selection:', error);
    }
  }
}

// Export singleton instance
const tenantManager = new MiaFlowTenantManager();
export default tenantManager;
